import { useTranslation } from 'react-i18next';

import gradients from 'src/shared/utils/gradients';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import InsertChartOutlinedOutlinedIcon from '@mui/icons-material/InsertChartOutlinedOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import { formatCurrency } from 'src/shared/utils/currency';
import { type CurrentCompanyType, type FlexflowStatisticsData } from './types';

export const flexflowStatisticsData =
  (
    t: any,
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    theme: any,
    currentCompany: CurrentCompanyType
  ) =>
  (flexflowTotals: FlexflowStatisticsData, premiumFeaturesDisabled?: boolean) => {
    const formatCompanyCurrency = formatCurrency(currentCompany?.locale, currentCompany?.currency);

    return {
      title: t('flexible compensation', { ns: 'common' }),
      gradient: premiumFeaturesDisabled ? gradients.grey : gradients.blue,
      data: [
        {
          headline: t('total consumed'),
          value: formatCompanyCurrency(flexflowTotals?.totalSpentAmount || 0),
          icon: (
            <MonetizationOnOutlinedIcon
              style={{ color: premiumFeaturesDisabled ? 'grey' : theme.palette.colorPalette[1] }}
            />
          )
        },
        {
          headline: t('average amount'),
          value: formatCompanyCurrency(flexflowTotals?.avgTransactionAmount || 0),
          icon: (
            <InsertChartOutlinedOutlinedIcon
              style={{ color: premiumFeaturesDisabled ? 'grey' : theme.palette.colorPalette[1] }}
            />
          )
        },
        {
          headline: `${t('employees who have applied for a card')}`,
          value: flexflowTotals?.employeesThatRequestedCard,
          icon: (
            <CreditCardOutlinedIcon
              style={{ color: premiumFeaturesDisabled ? 'grey' : theme.palette.colorPalette[1] }}
            />
          )
        }
      ]
    };
  };
